import { useLanguage } from '../../contexts/LanguageContext';
import {
  Heart, AlertTriangle, Users, Home, Pill, HandHeart, UtensilsCrossed,
  Stethoscope, Droplets, Baby, Truck, Search, Building2, Wifi, CheckCircle2
} from 'lucide-react';

const CATEGORY_CONFIG = [
  { id: 'richiesta_aiuto', icon: Heart, color: '#FF3B30' },
  { id: 'intervento_urgente', icon: AlertTriangle, color: '#FF3B30' },
  { id: 'sfollati', icon: Users, color: '#0A84FF' },
  { id: 'rifugio', icon: Home, color: '#32D74B' },
  { id: 'farmaci', icon: Pill, color: '#FF9F0A' },
  { id: 'aiuto_umanitario', icon: HandHeart, color: '#0A84FF' },
  { id: 'cibo', icon: UtensilsCrossed, color: '#FFD60A' },
  { id: 'emergenza_medica', icon: Stethoscope, color: '#FF3B30' },
  { id: 'acqua_igiene', icon: Droplets, color: '#0A84FF' },
  { id: 'protezione_minori', icon: Baby, color: '#FFD60A' },
  { id: 'evacuazione_trasporto', icon: Truck, color: '#FF9F0A' },
  { id: 'persone_scomparse', icon: Search, color: '#FF3B30' },
  { id: 'danni_infrastrutturali', icon: Building2, color: '#A0A0A0' },
  { id: 'blackout_comunicazioni', icon: Wifi, color: '#FF9F0A' },
  { id: 'checkin_sto_bene', icon: CheckCircle2, color: '#32D74B' },
];

export default function CategoryGrid({ selected, onSelect, compact = false }) {
  const { t } = useLanguage();

  return (
    <div
      className={compact
        ? 'grid grid-cols-3 sm:grid-cols-5 gap-2'
        : 'grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3'
      }
      data-testid="category-grid"
    >
      {CATEGORY_CONFIG.map(({ id, icon: Icon, color }) => {
        const isSelected = selected === id;
        return (
          <button
            key={id}
            onClick={() => onSelect(id)}
            className={`flex flex-col items-center gap-2 p-3 border transition-all text-center ${
              isSelected
                ? 'border-[#FF3B30] bg-[#FF3B30]/10'
                : 'border-[#B8D4E8] bg-white hover:border-[#FF3B30]/50 hover:bg-[#D6E8F5]'
            }`}
            data-testid={`category-${id}`}
          >
            <div
              className="w-10 h-10 flex items-center justify-center"
              style={{ color: isSelected ? '#FF3B30' : color }}
            >
              <Icon size={compact ? 20 : 24} />
            </div>
            <span className="text-[10px] sm:text-xs uppercase tracking-wider font-bold text-[#4A6B8A] leading-tight">
              {t(id)}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export { CATEGORY_CONFIG };
